import { disputeAlertViewSchema } from "@redotech/redo-dispute-common/dispute-alert-view-definition";
import * as z from "zod";

// Single alert for the detail page; null when not found / not this merchant's.
export const getDisputelyAlert = {
  name: "getDisputelyAlert" as const,
  input: z.object({ alertId: z.coerce.bigint() }),
  output: z.object({ alert: z.nullable(disputeAlertViewSchema) }),
};
